module.exports = __webpack_public_path__ + "img/icon_mine_pre.7be3ba65.png";